export const VALID_MIN = 'VALID_MIN';
export const VALID_MAX = 'VALID_MAX';

export const MIN = 'MIN';
export const MAX = 'MAX';

export const CONSTRAINED = 1;
export const FIXED = 2;
export const FDCL = 4;
